<template>
  <div class="mockup-section">
      <!-- Header -->
      <header class="section-header">
        <h2 class="section-title">
          Check out the mockups and share your feedback<br>
          to shape the future of POP backlinks tool
        </h2>
         <div class="carousel-indicators">
          <button 
            v-for="(slide, index) in slides" 
            :key="index"
            class="indicator"
            :class="{ active: index === currentSlide }"
            @click="goToSlide(index)"
          ></button>
        </div>
      </header>

      <!-- Carousel -->
      <div class="carousel-container">
        <div class="carousel-wrapper">
          <button class="carousel-nav prev" @click="prevSlide" :disabled="currentSlide === 0">
           <i class="fa fa-angle-left" aria-hidden="true"></i>
          </button>

          <div class="carousel-content">
            <div class="carousel-track" :style="{ transform: `translateX(-${currentSlide * 100}%)` }">
              <div class="carousel-slide" v-for="(slide, index) in slides" :key="index">
               <img :src="`/static/${slide.image}`" :alt="slide.title">
               <div v-html="slide.description" class="description"></div>
              </div>
            </div>
          </div>

          <button class="carousel-nav next" @click="nextSlide" :disabled="currentSlide === slides.length - 1">
          <i class="fa fa-angle-right" aria-hidden="true"></i>
          </button>
        </div>
      </div>

      <!-- Bottom Section -->
      <div class="bottom-section">
        <button class="feedback-btn" @click="shareFeedbackModal = true">
          Share feedback
        </button>
      </div>

        <div class="modal" :class="{ 'is-active': shareFeedbackModal }">
        <div class="modal-background" @click="closeModal"></div>
        <div class="modal-card">
          <header class="modal-card-head">
            <img src="/static/cross.svg" alt="cross icon" class="cross-icon" @click="closeModal">
            <p class="modal-card-title">Would you use POP Backlinks tool?</p>

          <div class="buttons-wrapper">
            <b-button
              class="btn"
              :class="{ selected: feedbackChoice === 'yes' }"
              @click="feedbackChoice = 'yes'"
            >
              Yes 👍
            </b-button>
            <b-button
              class="btn"
              :class="{ selected: feedbackChoice === 'no' }"
              @click="feedbackChoice = 'no'"
            >
              No 👎
            </b-button>
          </div>
          </header>
          <section class="modal-card-body">
            <b-field label="Any comments or thoughts?" customClass="custom-label">
             <b-input type="textarea" class="no-resize text-area" placeholder="I’d be interested to get link insertions" :rows="2" v-model="feedbackText"></b-input>
            </b-field>
          </section>
          <footer class="modal-card-foot">
            <button class="submit-btn" @click="submitFeedback">Submit</button>
          </footer>
        </div>
      </div>
  </div>
</template>

<script>
import router from '@/router'
export default {
  name: 'BacklinksMockupCarousel',
  data() {
    return {
      shareFeedbackModal: false,
      currentSlide: 0,
      feedbackText: '',
      feedbackChoice: '',
      slides: [
        { id: 4, title: 'Mockup 4', image: 'Backlinks tool-4.png', description: 'Step 1: quickly assess recommended backlink <br /> providers and their key domain metrics' },
        { id: 3, title: 'Mockup 3', image: 'Backlinks tool-3.png', description: 'Step 2A: Select provider, then order and purchase link insertion' },
        { id: 2, title: 'Mockup 2', image: 'Backlinks tool-2.png', description: 'Step 2B: Or select a guest post to let POP AI write it for you and purchase post placement' },
        { id: 1, title: 'Mockup 1', image: 'Backlinks tool-1.png', description: 'Step 3: Track progress of your orders' },
      ]
    }
  },
  methods: {
    nextSlide() {
      if (this.currentSlide < this.slides.length - 1) {
        this.currentSlide++
      }
    },
    prevSlide() {
      if (this.currentSlide > 0) {
        this.currentSlide--
      }
    },
    goToSlide(index) {
      this.currentSlide = index
    },
    closeModal() {
      this.shareFeedbackModal = false;
    },
    submitFeedback() {
  if (!this.feedbackChoice) {
    alert('Please choose Yes or No.');
    return;
  }

  const is_pop_useful = this.feedbackChoice === 'yes';
  const comment = this.feedbackText;

  this.$store.dispatch('submitPopFeedbackAction', {
    is_pop_useful,
    comment,
    dismiss: false,
  })
  .then(() => {
            this.$notify({
          group: "info",
          type: "success",
          duration: 3000,
          text: "Feedback submitted. Thank you!",
        });
    this.closeModal();
    this.feedbackText = '';
    this.feedbackChoice = '';
    router.push('/')
  })
  .catch(() => {
              this.$notify({
            group: 'info', type: 'error',
            text: 'Failed to submit feedback. Please try again later.'
          })
    this.closeModal();
    this.feedbackText = '';
    this.feedbackChoice = '';
  });
}

}
}
</script>

<style lang="scss" scoped>
    ::v-deep .no-resize textarea {
      resize: none;
      &:focus {
        outline: none;
      }
    }
    ::v-deep .no-resize textarea::placeholder {
      font-family: Mulish;
      font-weight: 400;
      font-style: Regular;
      font-size: 12px;
      line-height: 140%;
      letter-spacing: 0%;
      color: #757A7F;
    }

.mockup-section {

  .section-header {
       .carousel-indicators {
      display: flex;
      justify-content: center;
      gap: 8px;
      margin-top: 24px;
      margin-bottom: 24px;

      .indicator {
        width: 11px;
        height: 11px;
        border-radius: 50%;
        background: #cbd5e1;
        border: none;
        cursor: pointer;
        transition: all 0.3s ease;

        &.active {
          background: #64748b;
        }

        &:hover {
          background: #94a3b8;
        }
      }
    }

    .section-title {
      font-family: Mulish;
      font-weight: 700;
      font-style: Bold;
      font-size: 19px;
      line-height: 140%;
      letter-spacing: 0%;
      text-align: center;
      color: #000000;

      @media (max-width: 768px) {
        font-size: 1.75rem;
      }
    }
  }

  .carousel-container {
    margin-bottom: 20px;

    .carousel-wrapper {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 16px;

      .carousel-nav {
       font-size: x-large;
       color: #919191;
        cursor: pointer;
        transition: all 0.3s ease;
        z-index: 10;

        &:hover:not(:disabled) {
          background: #f8fafc;
          border-color: #cbd5e1;
        }

        &:disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }

        svg {
          color: #64748b;
        }
      }

      .carousel-content {
        width: 670px;
        overflow: hidden;

        .carousel-track {
          display: flex;
          transition: transform 0.5s ease;

          .carousel-slide {
            min-width: 100%;

            img {
              height: 470px;
              max-width: 670px;
            }

            div {
              width: 80%;
              margin: 0 auto;
              margin-top: 10px;
              text-align: center;
              font-family: Mulish;
              font-weight: 400;
              font-style: Regular;
              font-size: 17px;
              line-height: 140%;
              letter-spacing: 0%;
              text-align: center;
              color: #000000;
            }
          }
          .description{
              font-family: Mulish;
              font-weight: 400;
              font-style: Regular;
              font-size: 17px;
              line-height: 140%;
              letter-spacing: 0%;
              text-align: center;
              color: #000000;
            }
          }
        }
      }
    }


  .modal{
    .modal-card{
      width: 375px;
      border-radius: 7px;
      background-color: #ffffff;
      
      .modal-card-head{
        position: relative;
        background-color: #ffffff;
        border-bottom: none;
        display: flex;
        flex-direction: column;
        align-items: start;
        img{
          height: 12px;
          position: absolute;
          right: 14px;
          top: 15px;
        }

        .buttons-wrapper{
          display: flex;
          align-items: center;
          gap: 10px;
          .btn{
           width: 108px;
           padding: 10px;
           border-radius: 5px;
           display: flex;
           align-items: center;
           gap: 5px;
           font-family: Mulish;
           font-weight: 800;
           font-style: ExtraBold;
           font-size: 16px;
           line-height: 140%;
           letter-spacing: 0%;
          }
          .btn:first-of-type{
            color: #12843D;
          }
          .btn:last-of-type{
            color: #D11B1B;
          }
          .btn.selected {
            background-color: #fff7f0;
            border: 1px solid #ff630f;
            outline: none;
            box-shadow: none;
          }

        }
      }
      .modal-card-body{

        .custom-label{
          font-family: Mulish;
          font-weight: 700;
          letter-spacing: 0%;
          color: #171717;
        }
        .text-area{
          max-width: 338px;
        }
      }
      .modal-card-foot{
        background-color: #ffffff;
        border-top: none;
        display: flex;
        justify-content: flex-end;

        .submit-btn{
          max-width: 72px;
          border-radius: 6px;
          background-color: #FF630F;
          padding: 8px 10px;
          font-family: Mulish;
          font-weight: 700;
          font-style: Bold;
          font-size: 14px;
          line-height: 140%;
          letter-spacing: 0%;
          color: #FFFFFF;
        }
      }
      .modal-card-title{
        font-family: Mulish;
        font-weight: 700;
        font-style: Bold;
        font-size: 17px;
        line-height: 140%;
        letter-spacing: 0%;
        color: #171717;
      }
    }
  }

  .bottom-section {
    display: flex;
    justify-content: center;
    .feedback-btn {
      font-family: Mulish;
      background: #FF630F;
      color: white;
      border: none;
      padding: 14px 32px;
      border-radius: 8px;
      font-size: 17px;
      font-weight: 700;
      font-style: Bold;
      cursor: pointer;
      transition: all 0.3s ease;

      &:hover {
        background: #ea580c;
        transform: translateY(-1px);
      }
    }
  }

  @media (max-width: 768px) {
    padding: 40px 20px;

    .carousel-wrapper {
      flex-direction: column;
      gap: 16px;

      .carousel-nav {
        display: none;
      }
    }
  }
}
</style>